// extracted by mini-css-extract-plugin
var _1 = "syahU";
var _2 = "mef9n";
var _3 = "Ad2ig";
var _4 = "Sbk2a";
var _5 = "PWCaP";
var _6 = "qlirv";
var _7 = "smKoq";
var _8 = "QasBi";
var _9 = "Q7yE8";
export { _1 as "base", _2 as "breakWord", _3 as "content", _4 as "copyButton", _5 as "lineNumbers", _6 as "scrollable", _7 as "sqlView", _8 as "theme-dark", _9 as "theme-light" }
